import { Component, h } from 'preact';

export interface ToggleSwitchProps {
  label?: string,
  value?: boolean,
  onChange: (newValue: boolean) => any
}

/**
 * A toggle switch created using the FontAwesome toggle icon. Copied from
 * express-neighborhood-guide, and updated to match our current stateless
 * declarative patterns.
 */
export class ToggleSwitch extends Component<ToggleSwitchProps> {

  constructor(props: ToggleSwitchProps) {
    super(props);
  }

  getSwitchIcon() {
    if (this.props.value) {
      return (<i className="fa fa-toggle-on text-primary pr-2"></i>);
    } else {
      return (<i className="fa fa-toggle-off text-muted pr-2"></i>);
    }
  }

  onClick() {
    this.props.onChange(!this.props.value);
  }

  render(props: ToggleSwitchProps) {
    return (
      <span className="hi-toggle-switch" role="button" onClick={() => this.onClick()}>
        { this.getSwitchIcon() }
        { props.label }
      </span>
    );
  }
}
